import {Repository} from '@s-ui/domain'

/**
 * @interface
 */
export class UserAdsRepository extends Repository {
  getUserAds({userEntity}) {
    throw new Error('[UserAdsRepository#getUserAds] must be implemented')
  }

  renew({userEntity, adId}) {
    throw new Error('[UserAdsRepository#renew] must be implemented')
  }

  deleteUserAd({userEntity, adId}) {
    throw new Error('[UserAdsRepository#deleteUserAd] must be implemented')
  }
}
